const UserPage: React.FC = () => {
    return <h1>Welcome to the ClientUser Dashboard</h1>;
  };
  
  export default UserPage;
  